import { ReactElement } from "react";
import { useHistory } from "react-router";
import { className } from "../../../../shared/helpers";
import { useDependency } from "../../../../contexts/DependencyContext";
import { useTimeMachine } from "../../../../contexts/TimeMachineContext";
import { IWidget } from "../../../../services/http/widget/models/IWidget";
import { WidgetService } from "../../../../services/widgets/WidgetService";
import { ComponentModelService } from "../../../../services/ComponentModelService";
import styles from "./WidgetItem.module.scss";

interface WidgetItemProps
{
    index: number;
    widget: IWidget;
    visualClasses: string;
    enableScroll: Function;
}

const WidgetItem = (props: WidgetItemProps): ReactElement =>
{
    const timeMachine = useTimeMachine();
    const widgetService = useDependency(WidgetService);
    const service = useDependency(ComponentModelService);
    const { component } = service.componentModel;
    const history = useHistory();
    const widget = props.widget;
    const buttonProperties = widgetService.getButtonProperties(widget, component.id);

    return (
        <article
            {...className(styles.widgetItem, props.visualClasses)}
            style={{ animationDelay: `${props.index * 50}ms` }}
            onAnimationEnd={() => props.enableScroll(props.index)}
        >
            {/*-- Header --*/}
            <div className={styles.header}>
                <div className={styles.heading}>
                    <h3>{widget.name}</h3>

                    {widgetService.widgetHasBadge(widget.widgetTypeId) && (
                        <div className={styles.badge}>
                            {widgetService.getBadgeText(widget.widgetTypeId)}
                        </div>
                    )}
                </div>

                {buttonProperties && !timeMachine && buttonProperties.text !== '' && buttonProperties.url !== '' && (
                    <button className="btn btn-sm" onClick={() => history.push(buttonProperties.url)}>
                        {buttonProperties.text}
                    </button>
                )}
            </div>

            {/*-- Body --*/}
            <div className={styles.body}>
                {widgetService.getWidgetBody(widget)}
            </div>
        </article>
    );
};

export default WidgetItem;
